export enum OrderPaymentTypes {
    CreditCard = 1,
    Cash = 2,
    GiftCard = 3,
    Loyalty = 4
}